// extracted by mini-css-extract-plugin
export default {"options":"UserOptions_options__Sk86+","left_options":"UserOptions_left_options__GW1tI","right_options":"UserOptions_right_options__wTV8n","option":"UserOptions_option__vjNrr"};